var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg36(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 997,
    height: 370,
    viewBox: "0 0 997 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_896_13685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1010,
    height: 370
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1010V370H0V0Z",
    fill: "#031222"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_896_13685)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.523 64.2309L586.392 47.3631L586.48 47.2738V-7.99821H585.877V47.0245L569.008 63.8923L568.92 63.9816V100.23H569.523V64.2309Z",
    fill: "url(#paint0_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.527 64.2314L586.396 47.3628L586.484 47.2744V-7.99851H585.881V47.0242L569.011 63.8928L568.924 63.9813V100.231H569.527V64.2314Z",
    stroke: "url(#paint1_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.626 77.7809L592.238 110.167L592.665 110.595L624.876 78.3841H675.711L706.057 48.0377L706.146 47.9492V19.6625L726.729 -0.921738H927.646L932.923 -6.2001V-7.99683H932.32V-6.4502L927.396 -1.52493H726.48L705.63 19.324L705.543 19.4132V47.6999L675.461 77.7809H624.626Z",
    fill: "url(#paint2_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.627 77.7799L592.238 110.167L592.666 110.594L624.877 78.3831H675.712L706.058 48.0375L706.146 47.9482V19.6615L726.73 -0.922719H927.647L932.924 -6.20109V-7.9978H932.321V-6.45041L927.397 -1.52592H726.481L705.631 19.323L705.543 19.4122V47.6989L675.462 77.7799H624.627Z",
    stroke: "url(#paint3_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.321 62.7662C703.321 63.0509 703.405 63.3123 703.548 63.5351L674.461 92.6244H641.485L612.297 121.813L612.724 122.24L641.735 93.2276H674.71L703.976 63.9629C704.198 64.1061 704.46 64.1913 704.745 64.1913C705.532 64.1913 706.169 63.5528 706.169 62.7662C706.169 61.9788 705.532 61.3419 704.745 61.3419C703.959 61.3419 703.321 61.9788 703.321 62.7662Z",
    fill: "url(#paint4_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.709 93.2276L703.975 63.9622C704.197 64.1061 704.459 64.1906 704.744 64.1906C705.531 64.1906 706.168 63.5536 706.168 62.7662C706.168 61.9789 705.531 61.3419 704.744 61.3419C703.957 61.3419 703.319 61.9789 703.319 62.7662C703.319 63.0509 703.404 63.3131 703.547 63.5351L674.459 92.6244H641.484L612.295 121.813L612.723 122.24L641.734 93.2276H674.709Z",
    stroke: "url(#paint5_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.241 -7.99829V43.7406L642.089 59.8919H615.506L587.689 87.708C587.467 87.5641 587.205 87.4796 586.921 87.4796C586.134 87.4796 585.496 88.1166 585.496 88.904C585.496 89.6913 586.134 90.3291 586.921 90.3291C587.708 90.3291 588.346 89.6913 588.346 88.904C588.346 88.6201 588.26 88.3571 588.117 88.1351L615.756 60.495H642.339L658.755 44.0785L658.843 43.9908V-7.99829H658.241Z",
    fill: "url(#paint6_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.69 87.7075C587.468 87.5636 587.205 87.4791 586.921 87.4791C586.134 87.4791 585.496 88.1169 585.496 88.9035C585.496 89.6908 586.134 90.3286 586.921 90.3286C587.708 90.3286 588.346 89.6908 588.346 88.9035C588.346 88.6196 588.261 88.3574 588.117 88.1346L615.756 60.4945H642.339L658.755 44.0788L658.844 43.9903V-7.99878H658.241V43.7402L642.09 59.8913H615.507L587.69 87.7075Z",
    stroke: "url(#paint7_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.24 -7.99817V10.3454L618.721 25.8267V43.4729L581.086 81.106C580.864 80.962 580.602 80.8775 580.318 80.8775C579.53 80.8775 578.893 81.5154 578.893 82.3019C578.893 83.0885 579.53 83.7271 580.318 83.7271C581.104 83.7271 581.742 83.0885 581.742 82.3019C581.742 82.0172 581.658 81.755 581.514 81.533L619.236 43.8108L619.324 43.7231V25.5773L603.843 10.0953V-7.99817H603.24Z",
    fill: "url(#paint8_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.718 43.4725L581.084 81.1055C580.862 80.9615 580.6 80.8771 580.315 80.8771C579.528 80.8771 578.891 81.5148 578.891 82.3014C578.891 83.0888 579.528 83.7266 580.315 83.7266C581.102 83.7266 581.739 83.0888 581.739 82.3014C581.739 82.0175 581.655 81.7553 581.511 81.5325L619.234 43.8111L619.322 43.7226V25.5768L603.84 10.0956V-7.99865H603.237V10.3457L618.718 25.827V43.4725Z",
    stroke: "url(#paint9_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.338 -8V-5.62261L687.442 10.2736L687.354 10.3613V42.9339L660.587 69.7005H629.934C629.795 69.0587 629.225 68.5778 628.542 68.5778C627.755 68.5778 627.117 69.2147 627.117 70.0021C627.117 70.7887 627.755 71.4272 628.542 71.4272C629.225 71.4272 629.795 70.9447 629.934 70.3037H660.837L687.869 43.2733L687.956 43.184V10.6114L703.853 -5.284L703.942 -5.37329V-8H703.338Z",
    fill: "url(#paint10_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.934 69.7013C629.795 69.0595 629.225 68.5786 628.542 68.5786C627.755 68.5786 627.117 69.2155 627.117 70.0029C627.117 70.7903 627.755 71.4272 628.542 71.4272C629.225 71.4272 629.795 70.9463 629.934 70.3045H660.837L687.869 43.2741L687.957 43.1848V10.6122L703.853 -5.28321L703.942 -5.37248V-7.9992H703.339V-5.62179L687.442 10.2736L687.354 10.3629V42.9355L660.587 69.7013H629.934Z",
    stroke: "url(#paint11_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.261 75.0516L766.349 110.963H648.367L628.33 130.999L628.757 131.426L648.616 111.567H766.6L802.511 75.6548H1005.94V75.0516H802.261Z",
    fill: "url(#paint12_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.261 75.0516L766.35 110.963H648.367L628.33 130.998L628.758 131.426L648.617 111.566H766.6L802.511 75.6548H1005.94V75.0516H802.261Z",
    stroke: "url(#paint13_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.61 138.786L698.994 176.403H648.434V177.006H699.244L736.86 139.389H812.93L825.752 152.212L825.841 152.3H1005.94V151.697H826.091L813.269 138.874L813.18 138.786H736.61Z",
    fill: "url(#paint14_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.269 138.874L813.18 138.787H736.61L698.993 176.403H648.434V177.006H699.244L736.86 139.39H812.93L825.752 152.212L825.841 152.3H1005.94V151.697H826.09L813.269 138.874Z",
    stroke: "url(#paint15_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.37 148.921C806.37 149.206 806.455 149.468 806.598 149.69L785.05 171.239H720.91L705.428 186.722H650.848V187.325H705.678L721.16 171.843H785.3L807.026 150.118C807.248 150.261 807.511 150.346 807.795 150.346C808.582 150.346 809.22 149.708 809.22 148.921C809.22 148.135 808.582 147.497 807.795 147.497C807.008 147.497 806.37 148.135 806.37 148.921Z",
    fill: "url(#paint16_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.911 171.239L705.429 186.722H650.848V187.325H705.679L721.161 171.843H785.301L807.026 150.117C807.249 150.261 807.511 150.346 807.795 150.346C808.583 150.346 809.22 149.709 809.22 148.921C809.22 148.134 808.583 147.497 807.795 147.497C807.009 147.497 806.371 148.134 806.371 148.921C806.371 149.206 806.455 149.468 806.599 149.69L785.051 171.239H720.911Z",
    stroke: "url(#paint17_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.761 161.188L787.655 181.295H725.434C725.295 180.653 724.725 180.172 724.042 180.172C723.255 180.172 722.617 180.81 722.617 181.596C722.617 182.383 723.255 183.021 724.042 183.021C724.725 183.021 725.295 182.54 725.434 181.898H787.905L808.011 161.791H1005.94V161.188H807.761Z",
    fill: "url(#paint18_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.655 181.295H725.434C725.295 180.653 724.725 180.172 724.042 180.172C723.255 180.172 722.617 180.809 722.617 181.596C722.617 182.384 723.255 183.021 724.042 183.021C724.725 183.021 725.295 182.54 725.434 181.898H787.905L808.011 161.791H1005.94V161.188H807.761L787.655 181.295Z",
    stroke: "url(#paint19_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.387 92.0139H806.865L773.515 125.364H715.239L679.416 161.187H642.797V161.79H679.666L715.488 125.967H773.764L807.115 92.6179H974.387C974.525 93.2589 975.094 93.7407 975.777 93.7407C976.565 93.7407 977.203 93.1029 977.203 92.3155C977.203 91.529 976.565 90.8912 975.777 90.8912C975.094 90.8912 974.525 91.3729 974.387 92.0139Z",
    fill: "url(#paint20_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.386 92.6171C974.525 93.2589 975.094 93.7399 975.777 93.7399C976.565 93.7399 977.202 93.1029 977.202 92.3155C977.202 91.5282 976.565 90.8912 975.777 90.8912C975.094 90.8912 974.525 91.3721 974.386 92.0139H806.865L773.514 125.364H715.238L679.416 161.187H642.797V161.79H679.666L715.488 125.967H773.764L807.115 92.6171H974.386Z",
    stroke: "url(#paint21_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.76 112.898C798.76 113.685 799.398 114.323 800.185 114.323C800.868 114.323 801.438 113.841 801.576 113.2H818.826L835.627 130.002L835.716 130.089H1005.94V129.486H835.966L819.165 112.684L819.076 112.597H801.576C801.438 111.955 800.868 111.474 800.185 111.474C799.398 111.474 798.76 112.112 798.76 112.898Z",
    fill: "url(#paint22_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.163 112.684L819.074 112.597H801.574C801.435 111.955 800.866 111.473 800.182 111.473C799.396 111.473 798.758 112.111 798.758 112.898C798.758 113.685 799.396 114.323 800.182 114.323C800.866 114.323 801.435 113.841 801.574 113.2H818.824L835.625 130.001L835.714 130.089H1005.94V129.486H835.964L819.163 112.684Z",
    stroke: "url(#paint23_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.665 -7.99989V33.4324L961.984 54.114H793.989L746.433 101.67H686.446C686.354 100.973 685.763 100.432 685.04 100.432C684.253 100.432 683.615 101.07 683.615 101.857C683.615 102.644 684.253 103.282 685.04 103.282C685.681 103.282 686.216 102.856 686.396 102.273H746.683L794.239 54.7172H962.233L983.181 33.771L983.269 33.6826V-7.99989H982.665Z",
    fill: "url(#paint24_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.989 54.114L746.433 101.67H686.445C686.353 100.973 685.763 100.432 685.04 100.432C684.253 100.432 683.615 101.07 683.615 101.857C683.615 102.644 684.253 103.282 685.04 103.282C685.681 103.282 686.216 102.855 686.396 102.273H746.683L794.239 54.7172H962.232L983.18 33.771L983.269 33.6826V-7.99989H982.665V33.4324L961.983 54.114H793.989Z",
    stroke: "url(#paint25_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.684 -7.99814V24.0959L950.726 38.0547H772.06L720.231 89.8829C720.022 89.7631 719.784 89.6891 719.527 89.6891C718.739 89.6891 718.102 90.3269 718.102 91.1142C718.102 91.9016 718.739 92.5386 719.527 92.5386C720.313 92.5386 720.951 91.9016 720.951 91.1142C720.951 90.8046 720.85 90.5191 720.682 90.2867L772.31 38.6571H950.976L965.2 24.4337L965.287 24.346V-7.99814H964.684Z",
    fill: "url(#paint26_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.23 89.8821C720.021 89.7631 719.783 89.6891 719.526 89.6891C718.739 89.6891 718.102 90.3269 718.102 91.1134C718.102 91.9008 718.739 92.5386 719.526 92.5386C720.313 92.5386 720.951 91.9008 720.951 91.1134C720.951 90.8038 720.85 90.5191 720.682 90.2858L772.31 38.6571H950.975L965.199 24.4337L965.287 24.3452V-7.99894H964.683V24.0951L950.726 38.0539H772.059L720.23 89.8821Z",
    stroke: "url(#paint27_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.024 10.5892H746.434L728.254 28.7695L728.166 28.8579V61.2327L699.481 89.9183C699.259 89.7743 698.996 89.6891 698.711 89.6891C697.925 89.6891 697.287 90.3269 697.287 91.1142C697.287 91.9016 697.925 92.5386 698.711 92.5386C699.5 92.5386 700.137 91.9016 700.137 91.1142C700.137 90.8303 700.051 90.5673 699.908 90.3454L728.681 61.5721L728.769 61.4828V29.1081L746.684 11.1924H943.024C943.163 11.8342 943.732 12.3159 944.416 12.3159C945.202 12.3159 945.84 11.6781 945.84 10.8908C945.84 10.1034 945.202 9.46559 944.416 9.46559C943.732 9.46559 943.163 9.94737 943.024 10.5892Z",
    fill: "url(#paint28_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.434 10.5898L728.254 28.7693L728.165 28.8586V61.2342L699.48 89.919C699.258 89.775 698.996 89.6905 698.711 89.6905C697.925 89.6905 697.287 90.3283 697.287 91.1149C697.287 91.9023 697.925 92.54 698.711 92.54C699.499 92.54 700.137 91.9023 700.137 91.1149C700.137 90.831 700.051 90.568 699.907 90.346L728.681 61.5728L728.768 61.4835V29.1079L746.684 11.193H943.024C943.162 11.8348 943.731 12.3158 944.415 12.3158C945.202 12.3158 945.84 11.6788 945.84 10.8914C945.84 10.104 945.202 9.46706 944.415 9.46706C943.731 9.46706 943.162 9.94801 943.024 10.5898H746.434Z",
    stroke: "url(#paint29_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.357 -7.99883V37.7757L622.81 52.3208C622.589 52.1776 622.325 52.0916 622.042 52.0916C621.255 52.0916 620.617 52.7293 620.617 53.5167C620.617 54.3041 621.255 54.9419 622.042 54.9419C622.829 54.9419 623.467 54.3041 623.467 53.5167C623.467 53.2336 623.381 52.969 623.237 52.7478L637.872 38.1135L637.96 38.0258V-7.99883H637.357Z",
    fill: "url(#paint30_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.042 54.9424C622.829 54.9424 623.466 54.3046 623.466 53.518C623.466 53.2341 623.381 52.9703 623.237 52.7484L637.872 38.1148L637.959 38.0264V-7.99832H637.356V37.7762L622.81 52.3213C622.589 52.1781 622.325 52.0929 622.042 52.0929C621.254 52.0929 620.617 52.7307 620.617 53.518C620.617 54.3046 621.254 54.9424 622.042 54.9424Z",
    stroke: "url(#paint31_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.41 -7.99909V43.7407L654.111 62.0384C653.889 61.8944 653.627 61.81 653.343 61.81C652.556 61.81 651.918 62.4478 651.918 63.2343C651.918 64.0209 652.556 64.6587 653.343 64.6587C654.13 64.6587 654.767 64.0209 654.767 63.2343C654.767 62.9496 654.682 62.6875 654.539 62.4655L672.925 44.0785L673.014 43.9908V-7.99909H672.41Z",
    fill: "url(#paint32_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.342 61.8097C652.555 61.8097 651.918 62.4475 651.918 63.234C651.918 64.0214 652.555 64.6592 653.342 64.6592C654.13 64.6592 654.767 64.0214 654.767 63.234C654.767 62.9501 654.682 62.6879 654.538 62.4652L672.925 44.0789L673.013 43.9905V-7.9994H672.41V43.7403L654.111 62.0381C653.889 61.8941 653.627 61.8097 653.342 61.8097Z",
    stroke: "url(#paint33_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.687 119.165H679.291L663.608 134.848H651.544L645.471 140.919L645.899 141.347L651.794 135.451H663.858L679.54 119.768H689.687C689.825 120.41 690.394 120.892 691.078 120.892C691.865 120.892 692.502 120.254 692.502 119.466C692.502 118.679 691.865 118.041 691.078 118.041C690.394 118.041 689.825 118.523 689.687 119.165Z",
    fill: "url(#paint34_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.071 118.041C690.388 118.041 689.818 118.523 689.681 119.164H679.285L663.602 134.847H651.538L645.465 140.919L645.892 141.347L651.787 135.45H663.851L679.534 119.767H689.681C689.818 120.409 690.388 120.891 691.071 120.891C691.859 120.891 692.496 120.253 692.496 119.466C692.496 118.679 691.859 118.041 691.071 118.041Z",
    stroke: "url(#paint35_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.843 117.557H708.233L677.94 147.85H668.063C667.923 147.209 667.355 146.727 666.671 146.727C665.884 146.727 665.246 147.365 665.246 148.152C665.246 148.939 665.884 149.577 666.671 149.577C667.355 149.577 667.923 149.095 668.063 148.454H678.19L708.483 118.16H752.843C752.982 118.802 753.552 119.284 754.235 119.284C755.022 119.284 755.66 118.646 755.66 117.859C755.66 117.071 755.022 116.434 754.235 116.434C753.552 116.434 752.982 116.915 752.843 117.557Z",
    fill: "url(#paint36_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.234 116.433C753.551 116.433 752.981 116.915 752.843 117.556H708.233L677.94 147.85H668.062C667.923 147.208 667.354 146.727 666.67 146.727C665.883 146.727 665.246 147.364 665.246 148.152C665.246 148.938 665.883 149.576 666.67 149.576C667.354 149.576 667.923 149.094 668.062 148.453H678.189L708.482 118.159H752.843C752.981 118.801 753.551 119.283 754.234 119.283C755.022 119.283 755.659 118.645 755.659 117.858C755.659 117.071 755.022 116.433 754.234 116.433Z",
    stroke: "url(#paint37_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.307 125.499C788.307 126.286 788.944 126.923 789.732 126.923C790.415 126.923 790.984 126.443 791.123 125.801H809.446L828.659 145.015L828.747 145.103H985.921C986.059 145.745 986.629 146.227 987.312 146.227C988.099 146.227 988.737 145.589 988.737 144.801C988.737 144.014 988.099 143.376 987.312 143.376C986.629 143.376 986.059 143.858 985.921 144.5H828.997L809.784 125.285L809.695 125.198H791.123C790.984 124.556 790.415 124.075 789.732 124.075C788.944 124.075 788.307 124.713 788.307 125.499Z",
    fill: "url(#paint38_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.307 125.498C788.307 126.285 788.944 126.922 789.731 126.922C790.415 126.922 790.984 126.441 791.123 125.8H809.445L828.659 145.014L828.747 145.102H985.921C986.059 145.744 986.629 146.225 987.311 146.225C988.099 146.225 988.737 145.588 988.737 144.8C988.737 144.013 988.099 143.376 987.311 143.376C986.629 143.376 986.059 143.857 985.921 144.499H828.997L809.784 125.284L809.695 125.196H791.123C790.984 124.555 790.415 124.074 789.731 124.074C788.944 124.074 788.307 124.711 788.307 125.498Z",
    stroke: "url(#paint39_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.483 307.75L663.145 308.265L663.233 308.353H675.464L705.545 338.435V366.721L726.394 387.572L726.483 387.659H928.203L933.128 392.584V394.131H933.73V392.335L928.453 387.056H726.733L706.148 366.471V338.185L675.802 307.838L675.714 307.75H663.483Z",
    fill: "url(#paint40_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.145 308.265L663.233 308.353H675.463L705.545 338.435V366.721L726.394 387.571L726.483 387.659H928.203L933.127 392.584V394.131H933.73V392.334L928.453 387.056H726.732L706.148 366.471V338.185L675.802 307.838L675.714 307.75H663.483",
    stroke: "url(#paint41_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.33 255.133L648.277 275.081L648.367 275.169H766.349L802.172 310.992L802.261 311.081H1005.94V310.477H802.511L766.688 274.654L766.6 274.566H648.616L628.757 254.706L628.33 255.133Z",
    fill: "url(#paint42_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.686 274.654L766.598 274.566H648.614L628.755 254.706L628.328 255.134L648.275 275.081L648.365 275.169H766.347L802.17 310.993L802.259 311.081H1005.94V310.477H802.509L766.686 274.654Z",
    stroke: "url(#paint43_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.447 209.128V209.731H698.987L736.513 247.259L736.603 247.348H813.172L826.083 234.437H1005.94V233.834H825.833L812.922 246.744H736.852L699.324 209.216L699.236 209.128H652.447Z",
    fill: "url(#paint44_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.922 246.744H736.852L699.324 209.216L699.236 209.128H652.447V209.732H698.986L736.514 247.26L736.602 247.348H813.172L826.082 234.437H1005.94V233.834H825.833L812.922 246.744Z",
    stroke: "url(#paint45_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.617 204.538C722.617 205.326 723.255 205.963 724.042 205.963C724.725 205.963 725.295 205.482 725.434 204.841H787.655L807.673 224.859L807.761 224.946H1005.94V224.343H808.011L787.993 204.325L787.905 204.237H725.434C725.295 203.596 724.725 203.114 724.042 203.114C723.255 203.114 722.617 203.752 722.617 204.538Z",
    fill: "url(#paint46_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.993 204.325L787.905 204.237H725.434C725.295 203.595 724.725 203.113 724.042 203.113C723.255 203.113 722.617 203.751 722.617 204.539C722.617 205.325 723.255 205.963 724.042 205.963C724.725 205.963 725.295 205.481 725.434 204.84H787.655L807.673 224.858L807.761 224.947H1005.94V224.344H808.011L787.993 204.325Z",
    stroke: "url(#paint47_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.037 224.342V224.945H679.418L715.152 260.68L715.241 260.768H773.517L806.777 294.03L806.867 294.119H974.389C974.527 294.76 975.096 295.241 975.779 295.241C976.567 295.241 977.205 294.604 977.205 293.816C977.205 293.03 976.567 292.392 975.779 292.392C975.096 292.392 974.527 292.874 974.389 293.515H807.117L773.855 260.253L773.766 260.164H715.49L679.756 224.43L679.668 224.342H650.037Z",
    fill: "url(#paint48_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.768 260.165H715.492L679.758 224.431L679.67 224.343H650.039V224.946H679.42L715.154 260.681L715.242 260.769H773.518L806.78 294.03L806.868 294.119H974.39C974.529 294.761 975.098 295.242 975.782 295.242C976.568 295.242 977.206 294.604 977.206 293.817C977.206 293.03 976.568 292.392 975.782 292.392C975.098 292.392 974.529 292.874 974.39 293.516H807.119L773.857 260.253L773.768 260.165Z",
    stroke: "url(#paint49_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.945 160.148L223.034 160.235H259.595L279.184 173.391L279.273 173.479H419.449C419.588 174.121 420.157 174.603 420.841 174.603C421.628 174.603 422.265 173.965 422.265 173.177C422.265 172.391 421.628 171.753 420.841 171.753C420.157 171.753 419.588 172.234 419.449 172.876H279.523L259.933 159.72L259.845 159.632H223.284",
    stroke: "url(#paint50_linear_896_13685)",
    strokeWidth: 1.60852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.07 161.242H66.4532L30.7191 125.507L30.6306 125.419H1V126.023H30.3805L66.1146 161.758L66.2031 161.845H188.82L222.082 195.107L222.17 195.196H423.47C423.61 195.837 424.179 196.318 424.863 196.318C425.649 196.318 426.287 195.681 426.287 194.894C426.287 194.107 425.649 193.469 424.863 193.469C424.179 193.469 423.61 193.951 423.47 194.592H222.42L189.159 161.33L189.07 161.242Z",
    stroke: "url(#paint51_linear_896_13685)",
    strokeWidth: 1.60852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.716 256.044L818.826 272.933H801.576C801.438 272.291 800.868 271.81 800.185 271.81C799.398 271.81 798.76 272.447 798.76 273.235C798.76 274.022 799.398 274.66 800.185 274.66C800.868 274.66 801.438 274.178 801.576 273.536H819.076L835.966 256.647H1005.94V256.044H835.716Z",
    fill: "url(#paint52_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.824 272.933H801.574C801.435 272.291 800.866 271.81 800.182 271.81C799.396 271.81 798.758 272.447 798.758 273.235C798.758 274.022 799.396 274.659 800.182 274.659C800.866 274.659 801.435 274.178 801.574 273.536H819.074L835.964 256.647H1005.94V256.044H835.714L818.824 272.933Z",
    stroke: "url(#paint53_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.615 284.274C683.615 285.061 684.253 285.699 685.04 285.699C685.763 285.699 686.354 285.158 686.446 284.461H746.433L793.9 331.929L793.989 332.017H961.984L982.665 352.698V394.131H983.269V352.448L962.322 331.502L962.233 331.413H794.239L746.772 283.946L746.683 283.857H686.396C686.216 283.275 685.681 282.849 685.04 282.849C684.253 282.849 683.615 283.487 683.615 284.274Z",
    fill: "url(#paint54_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.233 331.414H794.239L746.772 283.946L746.683 283.858H686.396C686.217 283.276 685.681 282.85 685.04 282.85C684.253 282.85 683.615 283.487 683.615 284.275C683.615 285.061 684.253 285.699 685.04 285.699C685.763 285.699 686.354 285.159 686.446 284.461H746.434L793.9 331.93L793.99 332.017H961.983L982.665 352.699V394.131H983.269V352.449L962.322 331.502L962.233 331.414Z",
    stroke: "url(#paint55_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.102 295.018C718.102 295.805 718.739 296.443 719.527 296.443C719.784 296.443 720.022 296.369 720.231 296.25L771.972 347.991L772.06 348.079H950.726L964.684 362.036V394.131H965.287V361.787L951.065 347.563L950.976 347.475H772.31L720.682 295.847C720.85 295.613 720.951 295.328 720.951 295.018C720.951 294.232 720.313 293.594 719.527 293.594C718.739 293.594 718.102 294.232 718.102 295.018Z",
    fill: "url(#paint56_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.976 347.475H772.31L720.682 295.847C720.85 295.613 720.951 295.328 720.951 295.018C720.951 294.232 720.313 293.594 719.527 293.594C718.739 293.594 718.102 294.232 718.102 295.018C718.102 295.806 718.739 296.443 719.527 296.443C719.784 296.443 720.022 296.369 720.231 296.25L771.972 347.991L772.06 348.079H950.726L964.684 362.036V394.131H965.287V361.787L951.065 347.563L950.976 347.475Z",
    stroke: "url(#paint57_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.088 250.842L651.531 251.284H663.596L679.19 266.88L679.278 266.968H689.674C689.812 267.609 690.382 268.09 691.065 268.09C691.852 268.09 692.49 267.453 692.49 266.666C692.49 265.879 691.852 265.242 691.065 265.242C690.382 265.242 689.812 265.723 689.674 266.364H679.527L663.934 250.769L663.845 250.682H651.781L651.515 250.415L651.088 250.842Z",
    fill: "url(#paint58_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.531 251.284H663.595L679.19 266.88L679.278 266.968H689.674C689.812 267.609 690.382 268.09 691.065 268.09C691.852 268.09 692.49 267.453 692.49 266.666C692.49 265.879 691.852 265.242 691.065 265.242C690.382 265.242 689.812 265.723 689.674 266.364H679.528L663.934 250.769L663.845 250.681H651.781L651.515 250.415L651.088 250.842L651.531 251.284Z",
    stroke: "url(#paint59_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.332 316.7C585.332 317.487 585.969 318.125 586.756 318.125C587.04 318.125 587.302 318.04 587.525 317.896L625.159 355.529V373.175L609.766 388.567L609.679 388.656V407H610.282V388.906L625.675 373.513L625.763 373.424V355.279L587.952 317.469C588.096 317.247 588.181 316.984 588.181 316.7C588.181 315.913 587.543 315.275 586.756 315.275C585.969 315.275 585.332 315.913 585.332 316.7Z",
    fill: "url(#paint60_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.182 316.699C588.182 315.912 587.544 315.275 586.757 315.275C585.97 315.275 585.332 315.912 585.332 316.699C585.332 317.487 585.97 318.124 586.757 318.124C587.041 318.124 587.303 318.039 587.526 317.895L625.161 355.528V373.175L609.767 388.567L609.679 388.656V407H610.282V388.905L625.675 373.513L625.764 373.424V355.279L587.953 317.468C588.097 317.246 588.182 316.984 588.182 316.699Z",
    stroke: "url(#paint61_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.336 318.138C605.336 318.925 605.974 319.563 606.761 319.563C607.045 319.563 607.308 319.477 607.53 319.335L637.357 348.356V394.131H637.96V348.107L607.957 318.908C608.1 318.686 608.185 318.422 608.185 318.138C608.185 317.352 607.548 316.714 606.761 316.714C605.974 316.714 605.336 317.352 605.336 318.138Z",
    fill: "url(#paint62_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.185 318.139C608.185 317.352 607.548 316.715 606.761 316.715C605.974 316.715 605.336 317.352 605.336 318.139C605.336 318.926 605.974 319.563 606.761 319.563C607.044 319.563 607.308 319.478 607.53 319.335L637.357 348.357V394.131H637.96V348.107L607.957 318.908C608.1 318.687 608.185 318.423 608.185 318.139Z",
    stroke: "url(#paint63_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.566 329.334C661.566 330.121 662.204 330.758 662.991 330.758C663.276 330.758 663.538 330.674 663.76 330.529L682.059 348.828V400.567H682.662V348.578L664.188 330.103C664.331 329.88 664.416 329.617 664.416 329.334C664.416 328.546 663.778 327.909 662.991 327.909C662.204 327.909 661.566 328.546 661.566 329.334Z",
    fill: "url(#paint64_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.416 329.333C664.416 328.546 663.778 327.909 662.992 327.909C662.204 327.909 661.566 328.546 661.566 329.333C661.566 330.12 662.204 330.757 662.992 330.757C663.275 330.757 663.538 330.673 663.76 330.529L682.059 348.827V400.566H682.662V348.577L664.187 330.102C664.331 329.88 664.416 329.618 664.416 329.333Z",
    stroke: "url(#paint65_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.287 295.02C697.287 295.807 697.925 296.445 698.711 296.445C698.996 296.445 699.259 296.36 699.481 296.217L728.166 324.902V357.277L746.346 375.458L746.434 375.545H943.828C943.967 376.187 944.536 376.669 945.22 376.669C946.007 376.669 946.644 376.03 946.644 375.244C946.644 374.457 946.007 373.819 945.22 373.819C944.536 373.819 943.967 374.3 943.828 374.943H746.684L728.769 357.027V324.652L699.908 295.789C700.051 295.567 700.137 295.305 700.137 295.02C700.137 294.234 699.5 293.596 698.711 293.596C697.925 293.596 697.287 294.234 697.287 295.02Z",
    fill: "url(#paint66_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.219 373.817C944.536 373.817 943.966 374.299 943.828 374.94H746.684L728.768 357.025V324.649L699.907 295.787C700.051 295.565 700.137 295.303 700.137 295.018C700.137 294.231 699.499 293.594 698.711 293.594C697.925 293.594 697.287 294.231 697.287 295.018C697.287 295.805 697.925 296.443 698.711 296.443C698.996 296.443 699.258 296.358 699.48 296.215L728.165 324.899V357.275L746.345 375.455L746.434 375.543H943.828C943.966 376.185 944.536 376.667 945.219 376.667C946.007 376.667 946.644 376.029 946.644 375.241C946.644 374.455 946.007 373.817 945.219 373.817Z",
    stroke: "url(#paint67_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.246 237.981C665.246 238.767 665.884 239.406 666.671 239.406C667.355 239.406 667.923 238.924 668.063 238.282H677.94L708.145 268.488L708.233 268.576H752.843C752.982 269.218 753.552 269.699 754.235 269.699C755.022 269.699 755.66 269.061 755.66 268.274C755.66 267.488 755.022 266.85 754.235 266.85C753.552 266.85 752.982 267.331 752.843 267.973H708.483L678.278 237.768L678.19 237.68H668.063C667.923 237.037 667.355 236.556 666.671 236.556C665.884 236.556 665.246 237.194 665.246 237.981Z",
    fill: "url(#paint68_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.843 267.973H708.483L678.278 237.767L678.19 237.679H668.063C667.923 237.038 667.354 236.556 666.67 236.556C665.884 236.556 665.246 237.194 665.246 237.981C665.246 238.768 665.884 239.405 666.67 239.405C667.354 239.405 667.923 238.924 668.063 238.283H677.94L708.145 268.488L708.233 268.576H752.843C752.982 269.218 753.552 269.699 754.234 269.699C755.022 269.699 755.66 269.062 755.66 268.274C755.66 267.487 755.022 266.85 754.234 266.85C753.552 266.85 752.982 267.331 752.843 267.973Z",
    stroke: "url(#paint69_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.605 201.33H150.245L128.887 188.818L128.798 188.731H21.3556C21.2164 188.089 20.647 187.608 19.9634 187.608C19.1768 187.608 18.5391 188.245 18.5391 189.032C18.5391 189.819 19.1768 190.457 19.9634 190.457C20.647 190.457 21.2164 189.976 21.3556 189.334H128.548L149.906 201.846L149.995 201.933H194.605C194.744 202.575 195.313 203.056 195.996 203.056C196.784 203.056 197.421 202.419 197.421 201.632C197.421 200.844 196.784 200.207 195.996 200.207C195.313 200.207 194.744 200.688 194.605 201.33Z",
    stroke: "url(#paint70_linear_896_13685)",
    strokeWidth: 1.60852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.838 126.992C284.838 127.78 285.476 128.417 286.263 128.417C286.946 128.417 287.516 127.936 287.654 127.295H297.532L327.736 157.5L327.826 157.588H406.214C406.353 158.229 406.922 158.71 407.606 158.71C408.393 158.71 409.03 158.073 409.03 157.286C409.03 156.499 408.393 155.861 407.606 155.861C406.922 155.861 406.353 156.343 406.214 156.984H328.075L297.87 126.779L297.782 126.691H287.654C287.516 126.05 286.946 125.568 286.263 125.568C285.476 125.568 284.838 126.206 284.838 126.992Z",
    fill: "url(#paint71_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.216 156.987H328.077L297.872 126.782L297.784 126.694H287.656C287.517 126.052 286.948 125.571 286.264 125.571C285.478 125.571 284.84 126.208 284.84 126.996C284.84 127.782 285.478 128.42 286.264 128.42C286.948 128.42 287.517 127.939 287.656 127.297H297.534L327.738 157.503L327.827 157.591H406.216C406.355 158.232 406.924 158.713 407.607 158.713C408.395 158.713 409.032 158.076 409.032 157.289C409.032 156.502 408.395 155.865 407.607 155.865C406.924 155.865 406.355 156.346 406.216 156.987Z",
    stroke: "url(#paint72_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.447 198.806V199.41H705.42L720.813 214.803L720.902 214.891H785.042L806.59 236.441C806.447 236.663 806.362 236.925 806.362 237.21C806.362 237.997 807 238.634 807.787 238.634C808.574 238.634 809.211 237.997 809.211 237.21C809.211 236.423 808.574 235.784 807.787 235.784C807.502 235.784 807.24 235.87 807.018 236.013L785.38 214.376L785.292 214.288H721.152L705.758 198.894L705.67 198.806H652.447Z",
    fill: "url(#paint73_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.787 238.634C808.575 238.634 809.211 237.996 809.211 237.21C809.211 236.423 808.575 235.785 807.787 235.785C807.502 235.785 807.24 235.869 807.018 236.013L785.381 214.376L785.292 214.288H721.152L705.759 198.894L705.67 198.806H652.447V199.41H705.421L720.814 214.803L720.903 214.892H785.043L806.591 236.44C806.447 236.663 806.363 236.925 806.363 237.21C806.363 237.996 807 238.634 807.787 238.634Z",
    stroke: "url(#paint74_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.921 241.031H828.747L809.446 260.333H791.123C790.984 259.692 790.415 259.209 789.732 259.209C788.944 259.209 788.307 259.848 788.307 260.635C788.307 261.422 788.944 262.06 789.732 262.06C790.415 262.06 790.984 261.578 791.123 260.936H809.695L828.997 241.635H985.921C986.059 242.276 986.629 242.757 987.312 242.757C988.099 242.757 988.737 242.12 988.737 241.332C988.737 240.546 988.099 239.908 987.312 239.908C986.629 239.908 986.059 240.39 985.921 241.031Z",
    fill: "url(#paint75_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.115 260.936H809.687L828.99 241.634H985.913C986.051 242.275 986.621 242.756 987.304 242.756C988.091 242.756 988.729 242.119 988.729 241.332C988.729 240.545 988.091 239.908 987.304 239.908C986.621 239.908 986.051 240.389 985.913 241.03H828.739L809.437 260.333H791.115C790.976 259.691 790.407 259.21 789.724 259.21C788.937 259.21 788.299 259.847 788.299 260.634C788.299 261.422 788.937 262.059 789.724 262.059C790.407 262.059 790.976 261.578 791.115 260.936V260.936Z",
    stroke: "url(#paint76_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.336 228.765H200.053L219.356 209.463H410.058C410.196 210.105 410.766 210.586 411.449 210.586C412.236 210.586 412.874 209.949 412.874 209.162C412.874 208.374 412.236 207.737 411.449 207.737C410.766 207.737 410.196 208.218 410.058 208.86H219.105L199.803 228.162H116.336C116.197 227.52 115.628 227.039 114.945 227.039C114.157 227.039 113.52 227.676 113.52 228.464C113.52 229.251 114.157 229.888 114.945 229.888C115.628 229.888 116.197 229.407 116.336 228.765V228.765Z",
    stroke: "url(#paint77_linear_896_13685)",
    strokeWidth: 1.60852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.219 177.083L827.537 192.765H651.73V193.369H827.787L843.47 177.686H1005.94V177.083H843.219Z",
    fill: "url(#paint78_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.54 192.766H651.732V193.369H827.79L843.472 177.687H1005.94V177.084H843.222L827.54 192.766Z",
    stroke: "url(#paint79_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.688 244.238H11.5391V244.841H251.938L267.62 229.159H417.221V228.555H267.37L251.688 244.238Z",
    stroke: "url(#paint80_linear_896_13685)",
    strokeWidth: 1.60852,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.498 277.257C556.309 295.242 515.854 291.366 489.867 264.879C458.64 233.054 458.64 181.454 489.867 149.628C521.094 117.803 571.721 117.803 602.947 149.628C630.99 178.21 633.849 222.74 611.523 254.572L700.311 345.067L681.624 364.113L611.922 293.072C570.069 326.349 509.471 323.369 470.975 284.134C429.315 241.674 429.315 172.834 470.975 130.374C512.635 87.9141 580.179 87.9141 621.839 130.374C651.132 160.23 659.828 203.13 647.925 240.73",
    stroke: "url(#paint81_linear_896_13685)",
    strokeWidth: 3.21705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.93 247.651C636.93 243.828 639.971 240.729 643.722 240.729C647.473 240.729 650.514 243.828 650.514 247.651C650.514 251.474 647.473 254.573 643.722 254.573C639.971 254.573 636.93 251.474 636.93 247.651Z",
    stroke: "url(#paint82_linear_896_13685)",
    strokeWidth: 3.21705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.814 273.583C584.814 269.76 587.855 266.661 591.606 266.661C595.357 266.661 598.398 269.76 598.398 273.583C598.398 277.407 595.357 280.505 591.606 280.505C587.855 280.505 584.814 277.407 584.814 273.583Z",
    stroke: "url(#paint83_linear_896_13685)",
    strokeWidth: 3.21705,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.391 254.101C626.391 254.99 627.11 255.709 627.999 255.709C628.889 255.709 629.607 254.99 629.607 254.101C629.607 253.213 628.889 252.492 627.999 252.492C627.11 252.492 626.391 253.213 626.391 254.101Z",
    fill: "url(#paint84_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.608 254.101C629.608 254.99 628.888 255.709 627.999 255.709C627.111 255.709 626.391 254.99 626.391 254.101C626.391 253.213 627.111 252.492 627.999 252.492C628.888 252.492 629.608 253.213 629.608 254.101Z",
    stroke: "url(#paint85_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.242 229.245C417.242 230.132 417.963 230.853 418.851 230.853C419.739 230.853 420.459 230.132 420.459 229.245C420.459 228.357 419.739 227.636 418.851 227.636C417.963 227.636 417.242 228.357 417.242 229.245Z",
    fill: "url(#paint86_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.459 229.245C420.459 230.132 419.739 230.853 418.851 230.853C417.963 230.853 417.242 230.132 417.242 229.245C417.242 228.357 417.963 227.636 418.851 227.636C419.739 227.636 420.459 228.357 420.459 229.245Z",
    stroke: "url(#paint87_linear_896_13685)",
    strokeWidth: 1.20639,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.278 176.338L496.275 176.605C496.267 177.49 496.978 178.215 497.864 178.224L559.307 178.81C560.193 178.819 560.919 178.107 560.927 177.222L560.939 176.591C560.948 175.694 560.22 174.966 559.324 174.971L497.872 174.75C496.996 174.755 496.286 175.463 496.278 176.338Z",
    fill: "url(#paint88_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.43 176.698L565.428 176.963C565.419 177.85 566.131 178.575 567.016 178.583L604.097 179.169C604.982 179.177 605.708 178.466 605.716 177.58L605.728 176.95C605.737 176.054 605.01 175.325 604.113 175.331L567.023 175.109C566.148 175.115 565.438 175.822 565.43 176.698Z",
    fill: "url(#paint89_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.463 195.344L496.461 195.609C496.452 196.495 497.164 197.219 498.049 197.228L541.558 197.814C542.445 197.823 543.169 197.111 543.178 196.226L543.189 195.595C543.198 194.699 542.47 193.969 541.574 193.976L498.057 193.754C497.181 193.76 496.471 194.468 496.463 195.344Z",
    fill: "url(#paint90_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.797 195.343L547.795 195.609C547.786 196.495 548.498 197.219 549.384 197.228L605.017 197.814C605.904 197.823 606.628 197.111 606.636 196.225L606.648 195.595C606.656 194.699 605.929 193.969 605.033 193.975L549.391 193.753C548.516 193.76 547.806 194.467 547.797 195.343Z",
    fill: "url(#paint91_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.278 227.895L496.275 228.161C496.267 229.047 496.978 229.771 497.864 229.78L521.582 230.366C522.469 230.375 523.193 229.663 523.201 228.778L523.214 228.147C523.223 227.251 522.495 226.522 521.599 226.528L497.872 226.306C496.996 226.312 496.286 227.02 496.278 227.895Z",
    fill: "url(#paint92_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.331 228.253L528.328 228.518C528.319 229.405 529.03 230.13 529.917 230.138L583.193 230.725C584.08 230.733 584.805 230.022 584.814 229.135L584.825 228.505C584.834 227.609 584.106 226.88 583.21 226.886L529.925 226.665C529.049 226.67 528.339 227.377 528.331 228.253Z",
    fill: "url(#paint93_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.883 243.979L497.881 244.245C497.872 245.13 498.583 245.856 499.469 245.865L544.903 246.45C545.789 246.459 546.514 245.747 546.523 244.862L546.535 244.231C546.543 243.334 545.816 242.606 544.92 242.611L499.477 242.39C498.602 242.396 497.891 243.103 497.883 243.979Z",
    fill: "url(#paint94_linear_896_13685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.278 211.32L496.275 211.585C496.267 212.471 496.978 213.195 497.864 213.204L567.017 213.79C567.904 213.799 568.629 213.087 568.637 212.202L568.649 211.571C568.658 210.676 567.93 209.946 567.034 209.952L497.872 209.731C496.996 209.735 496.286 210.443 496.278 211.32Z",
    fill: "url(#paint95_linear_896_13685)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_896_13685",
    x1: 568.92,
    y1: 46.1159,
    x2: 586.48,
    y2: 46.1159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_896_13685",
    x1: 568.321,
    y1: -882.767,
    x2: 587.088,
    y2: -882.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_896_13685",
    x1: 592.238,
    y1: 51.2986,
    x2: 932.924,
    y2: 51.2986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_896_13685",
    x1: 591.385,
    y1: -860.977,
    x2: 933.527,
    y2: -860.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_896_13685",
    x1: 612.297,
    y1: 91.7906,
    x2: 706.17,
    y2: 91.7906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_896_13685",
    x1: 611.442,
    y1: -870.574,
    x2: 706.772,
    y2: -870.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_896_13685",
    x1: 585.496,
    y1: 41.165,
    x2: 658.844,
    y2: 41.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_896_13685",
    x1: 584.893,
    y1: -830.863,
    x2: 659.447,
    y2: -830.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_896_13685",
    x1: 578.893,
    y1: 37.864,
    x2: 619.324,
    y2: 37.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_896_13685",
    x1: 578.287,
    y1: -916.033,
    x2: 619.925,
    y2: -916.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_896_13685",
    x1: 627.117,
    y1: 31.7132,
    x2: 703.942,
    y2: 31.7132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_896_13685",
    x1: 626.514,
    y1: -857.425,
    x2: 704.545,
    y2: -857.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_896_13685",
    x1: 628.33,
    y1: 103.239,
    x2: 1005.94,
    y2: 103.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_896_13685",
    x1: 627.478,
    y1: -918.374,
    x2: 1006.55,
    y2: -918.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_896_13685",
    x1: 648.434,
    y1: 157.896,
    x2: 1005.94,
    y2: 157.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_896_13685",
    x1: 647.83,
    y1: -845.261,
    x2: 1006.55,
    y2: -845.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_896_13685",
    x1: 650.847,
    y1: 167.411,
    x2: 809.22,
    y2: 167.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_896_13685",
    x1: 650.244,
    y1: -790.045,
    x2: 809.823,
    y2: -790.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_896_13685",
    x1: 722.617,
    y1: 172.104,
    x2: 1005.94,
    y2: 172.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_896_13685",
    x1: 722.014,
    y1: -774.629,
    x2: 1006.54,
    y2: -774.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_896_13685",
    x1: 642.797,
    y1: 126.34,
    x2: 977.203,
    y2: 126.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_896_13685",
    x1: 642.194,
    y1: -906.22,
    x2: 977.805,
    y2: -906.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_896_13685",
    x1: 798.76,
    y1: 120.781,
    x2: 1005.94,
    y2: 120.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_896_13685",
    x1: 798.154,
    y1: -860.526,
    x2: 1006.54,
    y2: -860.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_896_13685",
    x1: 683.616,
    y1: 47.6407,
    x2: 983.269,
    y2: 47.6407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_896_13685",
    x1: 683.012,
    y1: -904.526,
    x2: 983.871,
    y2: -904.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_896_13685",
    x1: 718.102,
    y1: 42.2703,
    x2: 965.287,
    y2: 42.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_896_13685",
    x1: 717.498,
    y1: -827.62,
    x2: 965.89,
    y2: -827.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_896_13685",
    x1: 697.287,
    y1: 51.0024,
    x2: 945.84,
    y2: 51.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_896_13685",
    x1: 696.683,
    y1: -994.937,
    x2: 946.443,
    y2: -994.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_896_13685",
    x1: 620.617,
    y1: 23.4711,
    x2: 637.96,
    y2: 23.4711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_896_13685",
    x1: 620.014,
    y1: -878.701,
    x2: 638.563,
    y2: -878.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_896_13685",
    x1: 651.918,
    y1: 28.3298,
    x2: 673.014,
    y2: 28.3298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_896_13685",
    x1: 651.314,
    y1: -869.824,
    x2: 673.616,
    y2: -869.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_896_13685",
    x1: 645.471,
    y1: 129.694,
    x2: 692.503,
    y2: 129.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_896_13685",
    x1: 644.612,
    y1: -858.85,
    x2: 693.099,
    y2: -858.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_896_13685",
    x1: 665.246,
    y1: 133.005,
    x2: 755.66,
    y2: 133.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_896_13685",
    x1: 664.642,
    y1: -865.252,
    x2: 756.262,
    y2: -865.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_896_13685",
    x1: 788.307,
    y1: 135.15,
    x2: 988.737,
    y2: 135.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_896_13685",
    x1: 787.703,
    y1: -849.267,
    x2: 989.34,
    y2: -849.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_896_13685",
    x1: 663.145,
    y1: 350.94,
    x2: 933.731,
    y2: 350.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_896_13685",
    x1: 662.72,
    y1: -699.523,
    x2: 934.333,
    y2: -699.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_896_13685",
    x1: 628.33,
    y1: 282.893,
    x2: 1005.94,
    y2: 282.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_896_13685",
    x1: 627.475,
    y1: -698.574,
    x2: 1006.54,
    y2: -698.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_896_13685",
    x1: 652.448,
    y1: 228.238,
    x2: 1005.94,
    y2: 228.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_896_13685",
    x1: 651.844,
    y1: -699.863,
    x2: 1006.54,
    y2: -699.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_896_13685",
    x1: 722.617,
    y1: 214.03,
    x2: 1005.94,
    y2: 214.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_896_13685",
    x1: 722.014,
    y1: -770.494,
    x2: 1006.54,
    y2: -770.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_896_13685",
    x1: 650.037,
    y1: 259.792,
    x2: 977.204,
    y2: 259.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_896_13685",
    x1: 649.436,
    y1: -704.575,
    x2: 977.809,
    y2: -704.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_896_13685",
    x1: -328.443,
    y1: -711.919,
    x2: -127.753,
    y2: -711.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#133641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994413,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A273"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_896_13685",
    x1: 0.14402,
    y1: -463.034,
    x2: 427.143,
    y2: -463.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#133641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A273"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_896_13685",
    x1: 798.76,
    y1: 265.352,
    x2: 1005.94,
    y2: 265.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_896_13685",
    x1: 798.154,
    y1: -684.599,
    x2: 1006.54,
    y2: -684.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_896_13685",
    x1: 683.616,
    y1: 338.49,
    x2: 983.269,
    y2: 338.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_896_13685",
    x1: 683.012,
    y1: -640.776,
    x2: 983.872,
    y2: -640.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_896_13685",
    x1: 718.102,
    y1: 343.862,
    x2: 965.287,
    y2: 343.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_896_13685",
    x1: 717.498,
    y1: -614.026,
    x2: 965.891,
    y2: -614.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_896_13685",
    x1: 651.089,
    y1: 259.253,
    x2: 692.49,
    y2: 259.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_896_13685",
    x1: 650.235,
    y1: -721.672,
    x2: 693.093,
    y2: -721.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_896_13685",
    x1: 585.331,
    y1: 361.138,
    x2: 625.763,
    y2: 361.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_896_13685",
    x1: 584.729,
    y1: -692.852,
    x2: 626.366,
    y2: -692.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_896_13685",
    x1: 605.336,
    y1: 355.422,
    x2: 637.96,
    y2: 355.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_896_13685",
    x1: 604.733,
    y1: -684.258,
    x2: 638.563,
    y2: -684.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_896_13685",
    x1: 661.567,
    y1: 364.238,
    x2: 682.662,
    y2: 364.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_896_13685",
    x1: 660.963,
    y1: -670.685,
    x2: 683.265,
    y2: -670.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_896_13685",
    x1: 697.287,
    y1: 335.132,
    x2: 946.645,
    y2: 335.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_896_13685",
    x1: 696.683,
    y1: -552.61,
    x2: 947.247,
    y2: -552.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_896_13685",
    x1: 665.246,
    y1: 253.128,
    x2: 755.66,
    y2: 253.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_896_13685",
    x1: 664.643,
    y1: -682.296,
    x2: 756.263,
    y2: -682.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_896_13685",
    x1: 18.179,
    y1: 59.389,
    x2: 197.781,
    y2: 59.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#133641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A273"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_896_13685",
    x1: 284.838,
    y1: 142.139,
    x2: 409.031,
    y2: 142.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_896_13685",
    x1: 284.236,
    y1: -793.281,
    x2: 409.635,
    y2: -793.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_896_13685",
    x1: 652.448,
    y1: 218.72,
    x2: 809.212,
    y2: 218.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_896_13685",
    x1: 651.844,
    y1: -706.565,
    x2: 809.815,
    y2: -706.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_896_13685",
    x1: 788.307,
    y1: 250.983,
    x2: 988.737,
    y2: 250.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_896_13685",
    x1: 787.696,
    y1: -694.225,
    x2: 989.332,
    y2: -694.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_896_13685",
    x1: 112.917,
    y1: 23.8865,
    x2: 413.476,
    y2: 23.8865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#133641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A273"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_896_13685",
    x1: 651.73,
    y1: 185.226,
    x2: 1005.94,
    y2: 185.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_896_13685",
    x1: 651.13,
    y1: -764.808,
    x2: 1006.55,
    y2: -764.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_896_13685",
    x1: 10.7225,
    y1: 93.3875,
    x2: 418.038,
    y2: 93.3875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#133641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46A273"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_896_13685",
    x1: 439.206,
    y1: -2105.79,
    x2: 700.836,
    y2: -2105.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_896_13685",
    x1: 636.902,
    y1: 125.82,
    x2: 650.541,
    y2: 125.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_896_13685",
    x1: 584.787,
    y1: 151.752,
    x2: 598.426,
    y2: 151.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_896_13685",
    x1: 626.391,
    y1: 254.101,
    x2: 629.608,
    y2: 254.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_896_13685",
    x1: 625.788,
    y1: -711.012,
    x2: 630.211,
    y2: -711.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_896_13685",
    x1: 417.242,
    y1: 229.245,
    x2: 420.459,
    y2: 229.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_896_13685",
    x1: 416.639,
    y1: -735.869,
    x2: 421.062,
    y2: -735.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_896_13685",
    x1: 496.275,
    y1: 176.78,
    x2: 560.939,
    y2: 176.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_896_13685",
    x1: 565.428,
    y1: 177.139,
    x2: 605.728,
    y2: 177.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_896_13685",
    x1: 496.461,
    y1: 195.784,
    x2: 543.19,
    y2: 195.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_896_13685",
    x1: 547.795,
    y1: 195.784,
    x2: 606.648,
    y2: 195.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_896_13685",
    x1: 496.275,
    y1: 228.336,
    x2: 523.214,
    y2: 228.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_896_13685",
    x1: 528.328,
    y1: 228.694,
    x2: 584.825,
    y2: 228.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_896_13685",
    x1: 497.881,
    y1: 244.42,
    x2: 546.534,
    y2: 244.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_896_13685",
    x1: 496.275,
    y1: 211.76,
    x2: 568.649,
    y2: 211.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    stopColor: "#46A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133641"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg36);
export default __webpack_public_path__ + "static/media/img36.08d46f021c96c2c5bab77b8e2816d7b5.svg";
export { ForwardRef as ReactComponent };